import { axiosService } from 'ui-model';

// TODO pedro avoid importing from `@lumahealthhq/ui-model`
// eslint-disable-next-line no-restricted-imports
import { createQueryKey, useMutation, UseMutationOptions } from '@lumahealthhq/ui-model';
import { AxiosError } from 'axios';

const basePath = 'faxDocuments';
export type TErrorDefault = AxiosError<{ message?: string; payload?: any; statusCode?: number }>;

export default function useFaxArchiveById(options?: UseMutationOptions<unknown, TErrorDefault, string>) {
  const basePathFaxesByPatient = `${basePath}`;
  const variant = 'v2/{basePath}/{id}';

  async function mutationFn(id: string) {
    const params = { id, reviewStatus: 'archived' };
    const url = variant.replace('{basePath}', basePathFaxesByPatient).replace('{id}', id);
    const { data } = await axiosService.patch(url, { ...params });
    return data?.response || data || [];
  }

  const queryKey = createQueryKey(basePathFaxesByPatient, variant);
  const queryResult = useMutation(queryKey, mutationFn, options);
  return queryResult;
}
